import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import user from "../../assets/user.gif";

const Partnerwithusdashboard = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
    },
    {
      field: "firstName",
      headerName: "First Name",
      minWidth: 180,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      minWidth: 180,
    },
    {
      field: "contactNo",
      headerName: "Mobile No",
      minWidth: 180,
    },
    {
      field: "emailAddress",
      headerName: "Email",
      minWidth: 280,
    },
    {
      field: "inquiryType",
      headerName: "Inquiry Type",
      minWidth: 280,
    },
    {
      field: "title",
      headerName: "Title",
      minWidth: 200,
    },
    {
      field: "companyName",
      headerName: "Company Name",
      minWidth: 220,
    },
    {
      field: "website",
      headerName: "Website",
      minWidth: 300,
      renderCell: (params) => {
        const value = params.value;
        return value ? (
          <a
            href={
              value.startsWith("http")
                ? value
                : `https://${value}`
            }
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {value}
          </a>
        ) : (
          "-"
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      minWidth: 220,
    },
  ];

  function createData(
    id,
    firstName,
    lastName,
    contactNo,
    emailAddress,
    inquiryType,
    title,
    companyName,
    website,
    createdAt
  ) {
    return {
      id,
      firstName,
      lastName,
      contactNo,
      emailAddress,
      inquiryType,
      title,
      companyName,
      website,
      createdAt,
    };
  }

  const rows =
    tableData?.map((item) =>
      createData(
        item?.id || "-",
        item?.firstName || "-",
        item?.lastName || "-",
        item?.contactNo || "-",
        item?.emailAddress || "-",
        item?.inquiryType || "-",
        item?.title || "-",
        item?.companyName || "-",
        item?.website || "-",
        formatDateAndTime(item?.createdAt) || "-"
      )
    ) || [];

  useEffect(() => {
    getTableData();
  }, [paginationModel.page, paginationModel.pageSize]);

  const getTableData = async () => {
    try {
      setLoading(true);
      const { page, pageSize } = paginationModel;
      const offset = page * pageSize;
      const response = await fetch(
        `${apiUrl}/api/partnerwithusinquires?limit=${pageSize}&offset=${offset}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTableData(data?.entities?.rows || []);
        setTotalCount(
          Number(data?.entities?.count || 0)
        );
      } else {
        setTableData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error(
        "Error fetching partner with us data:",
        error
      );
      setTableData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-screen h-full backdrop-blur-sm sm:px-6 md:px-0">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-4 mt-6">
          <img
            className="w-20 h-20 rounded-full"
            src={user}
            alt="User"
          />

          <h1 className="text-2xl font-bold">
            Welcome back, {profile?.name}!
          </h1>
        </div>
      </div>

      <div
        style={{
          padding: "15px 20px",
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        Partner With Us List
      </div>

      <div style={{ margin: "20px 0" }}>
        <Commongrid
          rows={rows}
          columns={columns}
          totalCount={totalCount}
          loading={loading}
          handleViewClick={() => {}}
          api={getTableData}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          disableColumnMenu={true}
        />
      </div>
    </div>
  );
};

export default Partnerwithusdashboard;